export default __webpack_public_path__ + "static/media/10image.aa502ece.png";